import { render, staticRenderFns } from "./colisFutur.vue?vue&type=template&id=e9c1a084&"
import script from "./colisFutur.vue?vue&type=script&lang=js&"
export * from "./colisFutur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports